import { differenceInDays } from 'date-fns'
import calc from '@src/calc'

export const state = {
  checkIn: null,
  checkOut: null,
  promoCode: '',
}

export const getters = {
  searchParams: (state) => ({
    checkIn: state.checkIn,
    checkOut: state.checkOut,
    promoCode: state.promoCode,
  }),
  los: (state) => differenceInDays(state.checkOut, state.checkIn),
  trackingParams: (state, getters) => {
    const params = getters.searchParams
    const los = getters.los
    const roomCartItems = getters['rooms/cartItems']

    return Object.assign({}, { ...params, los, items: roomCartItems })
  },
  breakdown: (state, getters) => {
    const totalRoomsPrice = getters['rooms/totalPriceInCart']
    const totalExtrasPrice = getters['extras/totalPriceInCart']

    return calc.sumBreakdownPrice(totalRoomsPrice, totalExtrasPrice)
  },
  payload: (state, getters) => {
    const { searchParams } = getters
    const rooms = getters['rooms/payload']
    const extras = getters['extras/payload']

    return Object.assign({}, searchParams, { rooms, extras })
  },
  transactionDetails: (state, getters) => {
    const {
      currency,
      discount,
      tax,
      service,
      net: total,
      gross: grandTotal,
    } = getters.breakdown

    return { currency, total, discount, tax, service, grandTotal }
  },
}

export const mutations = {
  /* eslint-disable camelcase */
  SET_QUERY(state, { check_in, check_out, promo_code }) {
    state.checkIn = check_in
    state.checkOut = check_out
    state.promoCode = promo_code
  },
  /* eslint-enable */
}

export const actions = {}
